import React, { useState, useEffect, useContext, useRef } from 'react';
import { useHistory } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { useForm, Controller   } from 'react-hook-form'
import Button from "components/CustomButtons/Button.js";
import { NumberInput } from 'Ficha/components/NumberInput'
import { TextInput } from 'Ficha/components/TextInput'
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import CustomSnackbar from "components/Snackbar/CustomSnackbar.js";
import FeesLink from 'Ficha/pdf/feesLink'
import { CheckBoxInput } from 'Ficha/components/CheckBoxInput'
import { UserContext } from 'context/userContext'
import { atualizarOrcamento } from 'firebase/firestoreData'
import db from 'firebase/dbConfig'


const useStyles = makeStyles({
  root:{
    maxWidth: 640,
    margin: '20px auto'
  },
  header: {
    background: 'rgb(25, 50, 175)',
    color: 'lightgrey',
    padding: '10px !important',
    borderRadius: '4px'
  },
  row: {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: 5,

  },
  subheader: {
    width: 9,
    background: 'rgb(160, 40, 160)',
    backgroundColor: 'rgb(160, 40, 160)',
    fontSize: '55pt'
  },
  subheader2: {
  },
  greyBackground:{
    background: 'rgb(245, 245, 245)',
  },
  buttons:{
    display: 'flex',
    justifyContent: 'space-evenly',
    marginTop: 30,
  },
  btn:{
    width: 80,
  }
});

export default function FeesTable(props) {
  const classes = useStyles();
  const [ficha, setFicha] = useState(props.ficha)
  const procedimentos = props.ficha.procedimentos
  const tabela = props.tabela
  const history = useHistory();
  const initialMount = useRef(true)
  const { currentUser } = useContext(UserContext)
  const [showSuccessMessage, setShowSuccessMessage] = useState(false)
  const { register, handleSubmit, getValues, setValue, control } = useForm({
                                                                  defaultValues:{
                                                                    porteLinha1: ficha.orcamento.porteLinha1,
                                                                    porteLinha2: ficha.orcamento.porteLinha2,
                                                                    porteLinha3: ficha.orcamento.porteLinha3,
                                                                    porteLinha4: ficha.orcamento.porteLinha4,
                                                                    porteLinha5: ficha.orcamento.porteLinha5,
                                                                    porteLinha6: ficha.orcamento.porteLinha6,
                                                                    porteLinha7: ficha.orcamento.porteLinha7,
                                                                    porteLinha8: ficha.orcamento.porteLinha8,
                                                                    porteLinha9: ficha.orcamento.porteLinha9,
                                                                    valorLinha1: ficha.orcamento.valorLinha1,
                                                                    valorLinha2: ficha.orcamento.valorLinha2,
                                                                    valorLinha3: ficha.orcamento.valorLinha3,
                                                                    valorLinha4: ficha.orcamento.valorLinha4,
                                                                    valorLinha5: ficha.orcamento.valorLinha5,
                                                                    valorLinha6: ficha.orcamento.valorLinha6,
                                                                    valorLinha7: ficha.orcamento.valorLinha7,
                                                                    valorLinha8: ficha.orcamento.valorLinha8,
                                                                    valorLinha9: ficha.orcamento.valorLinha9,
                                                                    total: ficha.orcamento.total,
                                                                    dobrar: ficha.orcamento.dobrar,
                                                                    trinta: ficha.orcamento.trinta,
                                                                    obsOrcamento: ficha.orcamento.obsOrcamento,
                                                                  }})

  function handleCloseMessage() {
    setShowSuccessMessage(false)
  }

  function calcularLinha(index){
    setValue(`valorLinha${index+1}`,
            (getValues()[`percentualLinha${index+1}`] *
            tabela[getValues()[`porteLinha${index+1}`]] *
            (getValues()['dobrar'] ? 2 : 1) *
            (getValues()['trinta'] ? 1.3 : 1)).toFixed(2))
   }

  function calcularTotal(){
    let total = 0 
    procedimentos.split("\n").map((procedimento, index) => (
      total += Number(getValues()[`valorLinha${index+1}`])
    ))
    setValue("total", total.toFixed(2))
   }

   function recalcular() {
     procedimentos.split("\n").forEach((procedimento, index) => {
       if (getValues()[`porteLinha${index+1}`] !== ""){
         calcularLinha(index)
       }
     });
     calcularTotal()
   }

   useEffect(() => {
     if (!initialMount.current){
       recalcular()
    }
    initialMount.current = false
  },[tabela, procedimentos])

   useEffect(() => {
     if (currentUser){
       db.collection('fichas').doc(props.ficha.id)
       .onSnapshot(snapshot => {
         setFicha(snapshot.data());
         //console.log(allRecord);
       });
      }
  },[showSuccessMessage])

   const onSubmit = (data) => {
     atualizarOrcamento(props.ficha.id, data)
     setShowSuccessMessage(true)
   };

  return (
    <div className={classes.root}>
    <form onSubmit={handleSubmit(onSubmit)}>
      <Paper className={classes.header}>
        <Grid container spacing={0}>
          <Grid item md={6} sm={6} xs={6} className={classes.subheader1}>
            <Typography>Procedimento(s)</Typography>
          </Grid>
          <Grid item md={2} sm={2} xs={2} className={classes.subheader2}>
            <Typography align="center">Porte</Typography>
          </Grid>
          <Grid item md={2} sm={2} xs={2} className={classes.subheader2}>
            <Typography align="center">Via (%)</Typography>
          </Grid>
          <Grid item md={2} sm={2} xs={2} className={classes.subheader2}>
            <Typography align="center">Valor</Typography>
          </Grid>
        </Grid>
      </Paper>
      <div>
        {procedimentos.split("\n").map((procedimento, index) => (
          <div key={index + procedimento} className={index % 2 ? `${classes.greyBackground} ${classes.row}` : classes.row}>
            <Grid container spacing={0}>
              <Grid item md={6} sm={6} xs={6}>
                <Typography variant="caption">{`${index + 1}. ${procedimento}`}</Typography>
              </Grid>
              <Grid item md={2} sm={2} xs={2}>
                <NumberInput name={"porteLinha" + String(index+1)} onChange={()=>{calcularLinha(index); calcularTotal()}}  max={8} ref={register}/>
              </Grid>
              <Grid item md={2} sm={2} xs={2}>
              <Controller defaultValue={ficha.orcamento["percentualLinha" + String(index+1)] || 1} name={"percentualLinha" + String(index+1)} control={control}
                  render={({ onChange }) => (
                    <Select defaultValue={ficha.orcamento["percentualLinha" + String(index+1)]|| 1} onChange={(e)=>{onChange(e.target.value); calcularLinha(index); calcularTotal()}}>
                      <MenuItem value={1}>100%</MenuItem>
                      <MenuItem value={0.7}>70%</MenuItem>
                      <MenuItem value={0.5 }>50%</MenuItem>
                    </Select>
                )}
              />
              </Grid>
              <Grid item md={2} sm={2} xs={2}>
                <NumberInput name={"valorLinha" + String(index+1)} onChange={()=>{calcularTotal()}}  step="0.01" max={99999} ref={register}/>
              </Grid>
            </Grid>
            </div>
        ))}
        <Grid container spacing={2}>
          <Grid item md={8} sm={8} xs={8}>
            <Typography variant="h6" align="right">TOTAL:</Typography>
          </Grid>
          <Grid item md={4} sm={4} xs={4}>
            <NumberInput name="total" step="0.01" className={classes.valor} ref={register}/>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12} sm={12} md={12}>
            <TextInput className={classes.field} label="Observações" name="obsOrcamento" ref={register}/>
          </Grid>
        </Grid>
      </div>
      <Controller defaultValue={false} name="dobrar" control={control} render={(props) => (
          <CheckBoxInput label="Dobrar Valores (Acomodação: Apartamento)" onChange={(e) => {props.onChange(e.target.checked); recalcular()}} checked={props.value}/>)}
      />
      <Controller defaultValue={false} name="trinta" control={control} render={(props) => (
          <CheckBoxInput label="Adicionar 30% (Urgência / Horário Especial)" onChange={(e) => {props.onChange(e.target.checked); recalcular()}} checked={props.value}/>)}
      />
      <div className={classes.buttons}>
        <Button className={classes.btn} type="submit" color="primary">SALVAR</Button>
          <div>
            <FeesLink key={String(showSuccessMessage)}
                      info={ficha}
                      date={{date: props.ficha.data}}
                      link={<Button className={classes.btn} color="primary">IMPRIMIR</Button>}/>
          </div>
        <Button className={classes.btn} onClick={()=>{history.goBack()}} color="primary">CANCELAR</Button>
      </div>
      <CustomSnackbar open={showSuccessMessage} onClose={handleCloseMessage} message={"Os valores foram salvos com sucesso"}/>
      </form>
      </div>
  );
}
